import { IConfig } from ".";

export default {
    env: "staging",
    api: "https://api.snipe.staging.huismetbenen.nl"
} as IConfig;